import { defineStore } from 'pinia';
export const useSessionStore = defineStore('session', {
    state: () => {
        return {
            userId: null,
            sessionId: null,
            key: null
        };
    },
    getters: {
        getUserId: (state) => {
            return state.userId;
        },
        getSessionId: (state) => state.sessionId,
    },
    actions: {
        setSessionVars(key, uid, sid) {
            this.key = key;
            this.userId = uid;
            this.sessionId = sid;
            // localStorage.setItem('grasp_uid_'+key, uid)
            // localStorage.setItem('grasp_sid_'+key, sid)
        }
    },
});
